import { CheckStatus, Parse } from '../utils/ajax';

export default {
    execute(uri, method, body, authenticationToken, tenantId) {
        const addSlash = uri[0] !== '/';
        return fetch(`${addSlash ? '/' : ''}${uri}`, {
            method,
            headers: {
                Authorization: authenticationToken,
                ManyWhoTenant: tenantId,
                'Content-Type': 'application/json',
            },
            body,
        })
            .then(CheckStatus)
            .then(Parse);
    },
};
